/* 11:11 UAE — collection pages (Claude, Oct 26 2026, v4)
   1. Quick filter chips (gender / scent family) through the theme's facets.js
   2. Offer "how it works" sheet
   3. Search this collection by our name, the house or the original perfume (Arabic + English, spelling-tolerant)
   4. Add / − 1 + stepper on cards and search results, cart bar with the live total, silent cart-drawer refresh
   Loaded with defer by sections/main-collection-product-grid.liquid on collection pages and by snippets/ff-card-kit.liquid
   (layout/theme.liquid) everywhere else, so the add / stepper and the cart bar work on every page. No dependencies.
   v5 (Oct 26): the cart bar is on every page except the cart; the crossed-out total looks up the 99 price of items
   that are not on the page (product .js, kept for the visit) and is only shown once every item's price is known. */
(function () {
  'use strict';
  if (window.__ffcV4) return;
  window.__ffcV4 = true;

  var I = { ar: document.documentElement.lang === 'ar', cur: 'AED' };
  try { var j = document.getElementById('ffc-i18n'); if (j) I = Object.assign(I, JSON.parse(j.textContent)); } catch (e) {}
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var routes = window.routes || {};
  var ADD_URL = routes.cart_add_url || (root + 'cart/add');
  var CHANGE_URL = routes.cart_change_url || (root + 'cart/change');
  var CART_URL = root + 'cart.js';
  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function money(cents) {
    var v = Math.round(cents) / 100;
    var s = (v % 1 === 0 ? String(v) : v.toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return I.ar ? s + ' ' + I.cur : I.cur + ' ' + s;
  }
  function num(cents) { var v = Math.round(cents) / 100; return (v % 1 === 0 ? String(v) : v.toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  /* compare-at ("was") price per variant, from the cards on the page and the search index: the bar shows the 99-based total crossed out */
  var was = {};
  var WAS_KEY = 'ffWas', wasAsked = {};
  try { var ws = JSON.parse(sessionStorage.getItem(WAS_KEY) || '{}'); for (var wk in ws) was[wk] = ws[wk]; } catch (e) {}
  function collectWas(scope) { $$('[data-ffk][data-was]', scope).forEach(function (a) { var w = +a.getAttribute('data-was'); if (!isNaN(w)) was[a.getAttribute('data-variant')] = w; }); }
  /* items added elsewhere (product page form, another page): read their 99 price once from the product's .js */
  function fillWas(cart) {
    var hs = [];
    (cart.items || []).forEach(function (it) { if (was[it.variant_id] == null && it.handle && !wasAsked[it.handle]) { wasAsked[it.handle] = 1; hs.push(it.handle); } });
    if (!hs.length) return;
    Promise.all(hs.map(function (h) {
      return fetch(root + 'products/' + h + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { ((p && p.variants) || []).forEach(function (v) { was[v.id] = v.compare_at_price || 0; }); })
        .catch(function () {});
    })).then(function () {
      try { sessionStorage.setItem(WAS_KEY, JSON.stringify(was)); } catch (e) {}
      if (cartState) applyCart(cartState);
    });
  }
  function perfumes(n) {
    if (!I.ar) return n === 1 ? '1 perfume' : n + ' perfumes';
    if (n === 1) return 'عطر واحد';
    if (n === 2) return 'عطران';
    if (n <= 10) return n + ' عطور';
    return n + ' عطراً';
  }
  function results(n) {
    if (n === 1) return I.found1;
    if (n === 2) return I.found2;
    if (I.ar && n > 10) return I.foundM.replace('{n}', n);
    return I.foundN.replace('{n}', n);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function announce(msg) {
    var live = $('[data-ffc-live]'); if (!live) return;
    live.textContent = ''; requestAnimationFrame(function () { live.textContent = msg; });
  }

  /* 1. chips ------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.ffc-chip');
    if (!b) return;
    var k = b.getAttribute('data-k'), v = [];
    try { v = JSON.parse(b.getAttribute('data-v')) || []; } catch (er) {}
    var p = new URLSearchParams(location.search), cur = p.getAll(k);
    var on = v.some(function (x) { return cur.indexOf(x) > -1; });
    p.delete(k); p.delete('page');
    if (!on) v.forEach(function (x) { p.append(k, x); });
    var qs = p.toString();
    b.classList.toggle('is-active', !on); b.setAttribute('aria-pressed', String(!on));
    if (typeof FacetFiltersForm !== 'undefined' && document.getElementById('product-grid')) FacetFiltersForm.renderPage(qs);
    else location.href = location.pathname + (qs ? '?' + qs : '');
  });

  /* 2. offer sheet ------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-ffc-open]');
    if (o) {
      var d = document.getElementById(o.getAttribute('data-ffc-open'));
      if (d && d.showModal) { d.showModal(); d._opener = o; }
      return;
    }
    var c = e.target.closest && e.target.closest('[data-ffc-close]');
    if (c) { var dd = c.closest('dialog'); if (dd) dd.close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('ffo-sheet')) e.target.close();
  });

  /* 4. cart ------------------------------------------------------------- */
  var qty = {};            // variantId -> quantity in cart
  var cartState = null;
  var busy = {};

  function drawer() { return document.querySelector('cart-drawer'); }
  function refreshDrawer(sections, count) {
    var cd = drawer();
    if (!cd || !sections) return;
    try {
      var list = cd.getSectionsToRender ? cd.getSectionsToRender() : [];
      list.forEach(function (s) {
        var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
        var html = sections[s.id];
        if (!el || html == null) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var n = doc.querySelector(s.selector || '.shopify-section');
        if (n) el.innerHTML = n.innerHTML;
      });
      var di = cd.querySelector('.drawer__inner');
      cd.classList.toggle('is-empty', !count);
      if (di) di.classList.toggle('is-empty', !count);
    } catch (e) {}
  }
  function deal(cart) {
    var t = '';
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) { t += ' ' + ((a.discount_application && a.discount_application.title) || ''); });
    });
    (cart.cart_level_discount_applications || []).forEach(function (a) { t += ' ' + (a.title || ''); });
    if (/399/.test(t)) return I.deal6;
    if (/279/.test(t)) return I.deal4;
    return '';
  }
  // v6 (Oct 29): bar hint before the 4-for-279 offer; the cart opens once when the offer starts (collection/home pages) and after every add on product pages.
  function hint(cart) { var n = 0, ok = true; (cart.items || []).forEach(function (it) { var T = it.product_type; if (T === 'Eau de Parfum' || T === 'أو دي بارفان') n += it.quantity; else ok = false; }); if (!ok || n < 1 || n > 3) return ''; var m = 4 - n; return I.ar ? 'أضف ' + (m === 1 ? 'عطراً' : m === 2 ? 'عطرين' : m + ' عطور') + ': 4 بـ 279' : 'Add ' + m + ' more: 4 for AED 279'; }
  function inst(cart) { var box = document.querySelector('cart-drawer .ff-cart-trust'); if (!box) return; var p = box.querySelector('.ff-ct-inst'), t = cart.total_price || 0; if (!t) { if (p) p.hidden = true; return; } if (!p) { p = document.createElement('p'); p.className = 'ff-ct-inst'; box.insertBefore(p, box.firstChild); } var q = Math.floor(t / 4), a = 'AED ' + Math.floor(q / 100) + (q % 100 ? '.' + ('0' + (q % 100)).slice(-2) : ''); p.innerHTML = I.ar ? 'أو قسّمها على 4 دفعات بقيمة <strong>' + a + '</strong> مع تابي أو تمارا' : 'or 4 payments of <strong>' + a + '</strong> with Tabby or Tamara'; p.hidden = false; }
  var opened4 = false, b4 = '', b4n = 0, _sb = setBusy, _fc = fireChanged;
  setBusy = function (id, on) { if (on) { b4 = cartState ? deal(cartState) : ''; b4n = cartState ? cartState.item_count : 0; } _sb(id, on); };
  fireChanged = function (id, data) { _fc(id, data); var cd = drawer(); if (!cd || !cd.open || !cartState || !(cartState.item_count > b4n)) return; if (!/\/products\//.test(location.pathname)) { if (opened4 || b4 || !deal(cartState)) return; opened4 = true; } cd.open(document.activeElement); };
  function applyCart(cart) {
    cartState = cart;
    qty = {};
    (cart.items || []).forEach(function (it) { qty[it.variant_id] = (qty[it.variant_id] || 0) + it.quantity; }); inst(cart);
    paint();
    var bar = $('[data-ffbar]');
    if (!bar) return;
    var n = cart.item_count || 0;
    if (!n) { bar.hidden = true; document.documentElement.classList.remove('ffc-bar-on'); return; }
    $('[data-ffbar-count]', bar).textContent = perfumes(n);
    var ref = 0, known = true;
    (cart.items || []).forEach(function (it) { var w = was[it.variant_id]; if (w == null) known = false; ref += ((w && w > it.original_price) ? w : it.original_price) * it.quantity; });
    if (!known) fillWas(cart);
    $('[data-ffbar-total]', bar).innerHTML = (known && ref > cart.total_price ? '<s class="ffbar__was">' + num(ref) + '</s> ' : '') + esc(money(cart.total_price));
    var dl = deal(cart), de = $('[data-ffbar-deal]', bar);
    var hn = dl ? '' : hint(cart); de.textContent = dl || hn; de.hidden = !(dl || hn); de.classList.toggle('is-hint', !!hn);
    bar.hidden = false;
    document.documentElement.classList.add('ffc-bar-on');
  }
  function paint(scope) {
    $$('[data-ffc-add]', scope).forEach(function (btn) {
      var id = btn.getAttribute('data-ffc-add');
      var step = btn.parentNode.querySelector('[data-ffc-step="' + id + '"]');
      var q = qty[id] || 0;
      if (!step) return;
      var had = !btn.hidden && q > 0 && btn === document.activeElement;
      btn.hidden = q > 0;
      step.hidden = q === 0;
      var qe = step.querySelector('[data-ffc-qty]'); if (qe && qe.textContent !== String(q)) qe.textContent = q;
      var card = btn.closest('[data-ffk]'); if (card) card.classList.toggle('ffk--in', q > 0);
      if (had) { var inc = step.querySelector('[data-ffc-inc]'); if (inc) inc.focus(); }
    });
  }
  function getCart() {
    return fetch(CART_URL, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(applyCart).catch(function () {});
  }
  function fireChanged(id, data) {
    try { document.dispatchEvent(new CustomEvent('afterCartChanged', { detail: { productVariantId: id, source: 'ffc', cartData: data } })); } catch (e) {}
  }
  function nameOf(el) { var c = el.closest('[data-ffk], .ffs__item'); var b = c && c.querySelector('[data-ffc-name]'); return (b && b.getAttribute('data-ffc-name')) || ''; }
  function setBusy(id, on) {
    busy[id] = on;
    $$('[data-ffc-add="' + id + '"], [data-ffc-step="' + id + '"]').forEach(function (el) { el.classList.toggle('is-busy', on); el.setAttribute('aria-busy', String(on)); });
  }
  function add(id, label) {
    if (busy[id]) return;
    setBusy(id, true);
    var fd = new FormData();
    fd.append('id', id); fd.append('quantity', '1');
    fd.append('sections', SECTIONS); fd.append('sections_url', location.pathname);
    fetch(ADD_URL, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok || res.d.status) { announce(res.d.description || res.d.message || I.err); toast(res.d.description || I.err); return; }
        return getCart().then(function () {
          refreshDrawer(res.d.sections, cartState && cartState.item_count);
          announce(I.added.replace('{n}', label || ''));
          fireChanged(id, res.d);
        });
      })
      .catch(function () { toast(I.err); })
      .finally(function () { setBusy(id, false); });
  }
  function change(id, q, label) {
    if (busy[id]) return;
    var up = q > (qty[id] || 0);
    setBusy(id, true);
    fetch(CHANGE_URL, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ id: String(id), quantity: q, sections: SECTIONS, sections_url: location.pathname }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.items) { applyCart(cart); refreshDrawer(cart.sections, cart.item_count); fireChanged(id, cart); announce((up ? I.added : I.removed).replace('{n}', label || '')); }
        else { toast((cart && cart.description) || I.err); }
      })
      .catch(function () { toast(I.err); })
      .finally(function () { setBusy(id, false); });
  }
  var toastT;
  function toast(msg) {
    var t = $('.ffc-toast');
    if (!t) { t = document.createElement('div'); t.className = 'ffc-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-ffc-add]');
    if (a) { e.preventDefault(); add(a.getAttribute('data-ffc-add'), nameOf(a)); return; }
    var inc = e.target.closest && e.target.closest('[data-ffc-inc]');
    if (inc) { var id = inc.getAttribute('data-ffc-inc'); change(id, (qty[id] || 0) + 1, nameOf(inc)); return; }
    var dec = e.target.closest && e.target.closest('[data-ffc-dec]');
    if (dec) { var id2 = dec.getAttribute('data-ffc-dec'); change(id2, Math.max(0, (qty[id2] || 0) - 1), nameOf(dec)); return; }
    var cb = e.target.closest && e.target.closest('[data-ffc-cart]');
    if (cb) {
      var cd = drawer();
      if (!cd) { location.href = root + 'cart'; return; }
      fetch(root + '?sections=' + SECTIONS).then(function (r) { return r.json(); }).then(function (s) {
        refreshDrawer(s, cartState && cartState.item_count);
      }).catch(function () {}).finally(function () { cd.open(cb); });
    }
  });
  // keep cards in sync when the theme's own forms change the cart (drawer quantity, remove)
  document.addEventListener('afterCartChanged', function (e) { if (!e.detail || e.detail.source !== 'ffc') getCart(); });
  document.addEventListener('afterUpdateQuantity', function () { getCart(); });

  /* 3. search ----------------------------------------------------------- */
  var DIAC = /[ؐ-ًؚ-ٰٟۖ-ۭـ]/g;
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '')
      .replace(DIAC, '').replace(/[إأآٱ]/g, 'ا').replace(/ى/g, 'ي').replace(/ة/g, 'ه').replace(/ؤ/g, 'و').replace(/ئ/g, 'ي')
      .replace(/[^0-9a-zء-ي]+/g, ' ').trim();
  }
  function skel(s) { return norm(s).replace(/[اويaeiouy\s]/g, ''); }
  function grams(s) { var g = {}; for (var i = 0; i < s.length - 1; i++) g[s.substr(i, 2)] = 1; return g; }
  function dice(a, b) {
    if (a.length < 2 || b.length < 2) return 0;
    var A = grams(a), B = grams(b), n = 0, na = 0, nb = 0, k;
    for (k in A) { na++; if (B[k]) n++; } for (k in B) nb++;
    return (2 * n) / (na + nb);
  }
  function initials(s) { var w = norm(s).split(' ').filter(Boolean); return w.length > 1 ? w.map(function (x) { return x[0]; }).join('') : ''; }

  function Search(form) {
    this.f = form; this.inp = $('.ffs__input', form); this.panel = $('[data-ffs-panel]', form);
    this.list = $('[data-ffs-list]', form); this.status = $('[data-ffs-status]', form); this.clr = $('[data-ffs-clear]', form);
    this.items = null; this.loading = null; this.t = null;
    var s = this;
    this.inp.addEventListener('focus', function () { s.load(); if (s.inp.value.trim()) s.run(); });
    this.inp.addEventListener('input', function () { s.clr.hidden = !s.inp.value; clearTimeout(s.t); s.t = setTimeout(function () { s.run(); }, 90); });
    this.inp.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { s.close(); }
      if (e.key === 'ArrowDown') { var f = $('.ffs__hit', s.list); if (f) { e.preventDefault(); f.focus(); } }
    });
    this.list.addEventListener('keydown', function (e) {
      var hits = $$('.ffs__hit', s.list), i = hits.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' && i > -1 && i < hits.length - 1) { e.preventDefault(); hits[i + 1].focus(); }
      if (e.key === 'ArrowUp' && i > -1) { e.preventDefault(); (i === 0 ? s.inp : hits[i - 1]).focus(); }
      if (e.key === 'Escape') { s.close(); s.inp.focus(); }
    });
    this.clr.addEventListener('click', function () { s.inp.value = ''; s.clr.hidden = true; s.close(); s.inp.focus(); });
    form.addEventListener('submit', function (e) {
      var f = $('.ffs__hit', s.list);
      if (f && !s.panel.hidden) { e.preventDefault(); location.href = f.getAttribute('href'); }
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) s.close(); });
  }
  Search.prototype.load = function () {
    if (this.items || this.loading) return this.loading;
    var s = this, a = this.f.getAttribute('data-index'), b = this.f.getAttribute('data-index-en');
    var get = function (u) { return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) { return JSON.parse(t); }).catch(function () { return []; }); };
    this.loading = Promise.all([get(a), (b && b !== a) ? get(b) : Promise.resolve([])]).then(function (r) {
      var en = {}; r[1].forEach(function (x) { en[x.h] = x; });
      s.items = r[0].map(function (x, i) {
        if (x.v && x.c > x.p) was[x.v] = x.c;
        var e = en[x.h] || {};
        var hay = [x.n, x.t, x.ih, x.iha, x.ip, e.n, e.t, e.ip, x.h.replace(/^11-11-/, '').replace(/-/g, ' '), initials(x.ih), x.f, x.g, e.f, e.g].join(' ');
        var h = norm(hay);
        var words = h.split(' ').filter(function (w) { return w.length > 2; }).filter(function (w, k, a) { return a.indexOf(w) === k; });
        return { x: x, i: i, hay: ' ' + h + ' ', nm: norm(x.n), w: words, ws: words.map(skel) };
      });
      if (s.inp.value.trim()) s.run();
    });
    return this.loading;
  };
  Search.prototype.close = function () { this.panel.hidden = true; this.inp.setAttribute('aria-expanded', 'false'); };
  Search.prototype.run = function () {
    var q = this.inp.value.trim();
    if (!q) { this.close(); return; }
    this.panel.hidden = false; this.inp.setAttribute('aria-expanded', 'true');
    if (!this.items) { this.status.textContent = I.loading; this.list.innerHTML = ''; return; }
    var toks = norm(q).split(' ').filter(function (t) { return t.length > 1 || /\d/.test(t); });
    if (!toks.length) { this.close(); return; }
    var out = [];
    this.items.forEach(function (it) {
      var sc = 0;
      for (var k = 0; k < toks.length; k++) {
        var t = toks[k];
        if (it.hay.indexOf(' ' + t) > -1) sc += 3;
        else if (it.hay.indexOf(t) > -1) sc += 2;
        else {
          var st = skel(t), best = 0;
          if (st.length >= 2 && it.ws.some(function (x) { return x.indexOf(st) > -1; })) best = 0.7;
          if (t.length > 3) for (var w = 0; w < it.w.length; w++) {
            var ww = it.w[w], ratio = Math.min(ww.length, t.length) / Math.max(ww.length, t.length);
            if (ratio < 0.7) continue;
            var dd = Math.max(dice(t, ww), dice(st, it.ws[w])); if (dd > best) best = dd;
          }
          if (best >= 0.7) sc += best; else return;
        }
        if (it.nm.indexOf(t) === 0) sc += 3;
      }
      if (it.x.a) sc += 0.5;
      out.push({ it: it, sc: sc });
    });
    out.sort(function (a, b) { return b.sc - a.sc || a.it.i - b.it.i; });
    var top = out.slice(0, 8);
    this.status.textContent = top.length ? results(out.length) : I.none.replace('{q}', q);
    this.list.innerHTML = top.map(function (o) {
      var x = o.it.x, orig = x.ip || (I.ar ? (x.iha || x.ih) : x.ih) || '';
      var sub = ''; /* 11:11 (Oct 26): "Inspired by" hidden in results at the owner's request; matching on the original name stays */
      var dn = (x.b ? '11:11 ' : '') + x.n;
      if (x.d) sub = x.d + (sub ? (I.ar ? '، ' : ', ') + sub : '');
      var btn = '';
      if (!x.a) btn = '';
      else if (x.vc === 1 && x.v) btn = '<button type="button" class="ffs__add" data-ffc-add="' + x.v + '" data-ffc-name="' + esc(dn) + '" aria-label="' + esc((I.ar ? 'أضف ' : 'Add ') + dn) + '"><svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M8 3.5v9M3.5 8h9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></button>' +
        '<span class="ffs__in" data-ffc-step="' + x.v + '" hidden><span data-ffc-qty>1</span> ' + esc(I.in_cart) + '</span>';
      return '<li class="ffs__item"><a class="ffs__hit" href="' + esc(x.u) + '">' +
        (x.img ? '<img src="' + esc(x.img) + '" alt="" width="48" height="48" loading="lazy">' : '<span class="ffs__noimg"></span>') +
        '<span class="ffs__txt"><span class="ffs__n">' + (x.b ? '<span class="ffk__brand" dir="ltr">11:11</span> ' : '') + esc(x.n) + '</span>' + (sub ? '<span class="ffs__s">' + esc(sub) + '</span>' : '') +
        '<span class="ffs__p">' + money(x.p) + (x.c > x.p ? ' <s class="ffs__was">' + num(x.c) + '</s>' : '') + '</span></span></a>' + btn + '</li>';
    }).join('');
    paintSearch(this.list);
  };
  function paintSearch(scope) {
    $$('.ffs__add', scope).forEach(function (b) {
      var id = b.getAttribute('data-ffc-add'), q = qty[id] || 0, s = b.parentNode.querySelector('[data-ffc-step]');
      b.classList.toggle('is-in', q > 0);
      if (s) { s.hidden = q === 0; var qe = s.querySelector('[data-ffc-qty]'); if (qe && qe.textContent !== String(q)) qe.textContent = q; }
    });
  }

  /* boot ---------------------------------------------------------------- */
  function markCurrentPill() {
    var sc = document.querySelector('[id$="__1775725313ac6ad05e"]');
    if (!sc) return;
    var here = location.pathname.replace(/\/$/, '');
    $$('a[href]', sc).forEach(function (a) {
      if (a.pathname.replace(/\/$/, '') === here) { a.classList.add('ffc-here'); a.setAttribute('aria-current', 'page'); }
    });
  }
  function boot() {
    markCurrentPill();
    collectWas();
    $$('[data-ffs]').forEach(function (f) { if (!f._ffs) f._ffs = new Search(f); });
    var g = document.getElementById('ProductGridContainer');
    var fetched = false;
    if (g || document.querySelector('[data-ffk]')) { fetched = true; getCart(); }
    /* the cart bar on pages without cards yet (product page before its rows load): only ask for the cart when it has items */
    var fb = $('[data-ffbar]');
    if (!fetched && fb && +(fb.getAttribute('data-n') || 0) > 0) { fetched = true; getCart(); }
    if (g && window.MutationObserver) new MutationObserver(function (ms) {
      var hit = ms.some(function (m) { return Array.prototype.some.call(m.addedNodes, function (n) { return n.nodeType === 1 && (n.matches('[data-ffk], li, ul') || n.querySelector('[data-ffc-add]')); }); });
      if (hit) { collectWas(g); paint(g); }
    }).observe(g, { childList: true, subtree: true });
    /* other pages (homepage rows, You may also like, recently viewed, search, cart): cards also arrive later by AJAX */
    if (!g && window.MutationObserver) {
      var queued = false;
      new MutationObserver(function (ms) {
        if (queued) return;
        var hit = ms.some(function (m) { return Array.prototype.some.call(m.addedNodes, function (n) { return n.nodeType === 1 && (n.matches('[data-ffk]') || !!n.querySelector('[data-ffk]')); }); });
        if (!hit) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          collectWas();
          if (!fetched) { fetched = true; getCart(); } else { paint(); }
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('afterCartChanged', function () { $$('.ffs__list').forEach(paintSearch); });
  }
  var _apply = applyCart;
  applyCart = function (c) { _apply(c); $$('.ffs__list').forEach(paintSearch); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
